var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"heaer-text"},[_vm._v("全部维度报表")]),_c('div',{staticClass:"table-wrap"},[_c('demension-filter',{on:{"refreshTable":_vm.refreshTable,"downloadFile":_vm.downloadFile}}),_c('demension-table',{ref:"usertable",attrs:{"column":_vm.column,"list":_vm.list,"loading":_vm.loading}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }